export default __webpack_public_path__ + "static/media/black-zoom-in-icon.19250efd.svg";